/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Karol Pawlak <kpa@giap.pl>, April 2020
 */

import React, { PropTypes } from 'react';
import { layoutColorStyle, headerStyle, getThemeFromLocalStorage } from '../utils/utils';


class DeklaracjaDostepnosci extends React.Component {
  static propTypes = {
    children: PropTypes.node,
  };

  state = {
    colors: 'normal',
    style: {},
    districtData: {},
  }

  componentDidMount() {
    const colors = getThemeFromLocalStorage();
    let style = {};
    if (colors !== 'normal') {
      style = {
        color: headerStyle[colors].color,
      };
    }
    if (colors === 'intenseYellowBlack') {
      style = {
        color: headerStyle[colors].backgroundColor,
      };
    }
    this.setState({ colors, style });

    const url = `${process.env.API_URL}/eservices/declaration_of_availability/${this.props.prefix}/`;
    fetch(url, {
      method: 'GET',
    }).then(r => r.json())
      .then(resp => {
        this.setState({
          districtData: resp,
        });
      });

  }

  render() {
    return (
      <div style={this.state.style}>
        <h2 id="page-title">
          <b>Deklaracja dostępności</b>
        </h2>
        <h3 id="oswiadczenie">
          <b>Oświadczenie w sprawie dostępności</b>
        </h3>
        <div id="a11y-wstep" style={{ textAlign: 'justify' }}><span id="a11y-podmiot"><b>{this.state.districtData.district}</b></span> zobowiązuje się zapewnić dostępność swojej strony internetowej zgodnie z ustawą z dnia 4 kwietnia 2019 r. o dostępności cyfrowej stron internetowych i aplikacji mobilnych podmiotów publicznych. Oświadczenie w sprawie dostępności ma zastosowanie do <a href={this.props.url} id="a11y-url">{this.props.url}</a>
          {(this.state.districtData.has_mobile_app && this.state.districtData.district === 'Urząd Miasta Gorzowa Wielkopolskiego') ? <span>, <a href={'https://play.google.com/store/apps/details?id=com.dm.giapgorzow'} id="a11y-url">https://play.google.com/store/apps/details?id=com.dm.giapgorzow</a></span> : null}
          {(this.state.districtData.has_mobile_app && this.state.districtData.district !== 'Urząd Miasta Gorzowa Wielkopolskiego') ? <span>, <a href={'https://apps.apple.com/pl/app/euslugi-sip/id1484627587?l=pl'} id="a11y-url">https://apps.apple.com/pl/app/euslugi-sip/id1484627587?l=pl</a>, <a href={'https://play.google.com/store/apps/details?id=com.dm.giap'} id="a11y-url">https://play.google.com/store/apps/details?id=com.dm.giap</a></span> : null}.

        </div>
        <br />
        
        <p>Data publikacji: <span id="a11y-data-aktualizacja">{this.state.districtData.createdAt}</span>.<br />Data ostatniej istotnej aktualizacji: <span id="a11y-data-aktualizacja">{this.state.districtData.updatedAt}</span>.</p>
        <p style={{ textAlign: 'justify' }}>
          Deklarację sporządzono w dniu: <span id="a11y-data-sporzadzenie">{this.state.districtData.createdAt}</span> na podstawie samooceny przeprowadzonej przez podmiot publiczny.
        </p>

        <h3 id="a11y-kontakt"> <b>Stan dostępności cyfrowej</b></h3>
        <p style={{ textAlign: 'justify' }}>
        <span id="a11y-dostepnosc-cyfrowa">{this.state.districtData.digital_access_desc}</span>
        </p>
        <h3 id="a11y-kontakt"> <b>Informacje zwrotne i dane kontaktowe</b></h3>
        <p style={{ textAlign: 'justify' }}>W przypadku problemów z dostępnością strony internetowej prosimy o kontakt. Osobą kontaktową jest <span id="a11y-osoba">{this.state.districtData.person_name}</span>, <span id="a11y-email">{this.state.districtData.person_email}</span>. Kontaktować można się także dzwoniąc na numer telefonu <span id="a11y-telefon">{this.state.districtData.person_phone_number}</span>. Tą samą drogą można składać wnioski o udostępnienie informacji niedostępnej oraz składać żądania zapewnienia dostępności.</p>
        <p id="a11y-procedura" style={{ textAlign: 'justify' }}> Każdy ma prawo do wystąpienia z żądaniem zapewnienia dostępności cyfrowej strony internetowej, aplikacji mobilnej lub jakiegoś ich elementu. Można także zażądać udostępnienia informacji za pomocą alternatywnego sposobu dostępu, na przykład przez odczytanie niedostępnego cyfrowo dokumentu, opisanie zawartości filmu bez audiodeskrypcji itp. Żądanie powinno zawierać dane osoby zgłaszającej żądanie, wskazanie, o którą stronę internetową lub aplikację mobilną chodzi oraz sposób kontaktu. Jeżeli osoba żądająca zgłasza potrzebę otrzymania informacji za pomocą alternatywnego sposobu dostępu, powinna także określić dogodny dla niej sposób przedstawienia tej informacji. Podmiot publiczny powinien zrealizować żądanie niezwłocznie, nie później niż w ciągu 7 dni od dnia wystąpienia z żądaniem. Jeżeli dotrzymanie tego terminu nie jest możliwe, podmiot publiczny niezwłocznie informuje o tym wnoszącego żądanie, kiedy realizacja żądania będzie możliwa, przy czym termin ten nie może być dłuższy niż 2 miesiące od dnia wystąpienia z żądaniem. Jeżeli zapewnienie dostępności cyfrowej nie jest możliwe, podmiot publiczny może zaproponować alternatywny sposób dostępu do informacji. W przypadku, gdy podmiot publiczny odmówi realizacji żądania zapewnienia dostępności lub alternatywnego sposobu dostępu do informacji, wnoszący żądanie możne złożyć skargę w sprawie zapewniana dostępności cyfrowej strony internetowej, aplikacji mobilnej lub elementu strony internetowej, lub aplikacji mobilnej. Po wyczerpaniu wskazanej wyżej procedury można także złożyć wniosek do Rzecznika Praw Obywatelskich. Link do strony internetowej <a href="https://www.rpo.gov.pl/" target="_blank">Rzecznika Praw Obywatelskich</a>.</p>

        <h3 id="a11y-atchitektura"><b>Dostępność architektoniczna</b></h3>

        <ol style={{ textAlign: 'justify' }}>
          <li>Na stronie internetowej można korzystać ze standardowych skrótów klawiaturowych.</li>
          {this.state.districtData.is_description_link ?
            <li>Opis dostępności architektonicznej dostępny jest na stronie <a href={this.state.districtData.description_link} id="architectural-availability-description-url">{this.state.districtData.description_link}</a>.</li>
            : null}
          {!this.state.districtData.is_description_link && this.state.districtData.desc_list ?
            this.state.districtData.desc_list.map(
            (description) => { if (!description.is_translator_description) { return (<li>{description.description}</li>); } return (null); },
            )
            : null}
          {this.state.districtData.is_translator_link ?
            <li>Informacje o możliwości skorzystania z tłumacza języka migowego dostępne są na stronie <a href={this.state.districtData.translator_link} id="architectural-availability-description-url">{this.state.districtData.translator_link}</a>.</li>
            : null}
          {!this.state.districtData.is_translator_link && this.state.districtData.desc_list ?
            this.state.districtData.desc_list.map(
            (description) => { if (description.is_translator_description) { return (<li>{description.description}</li>); } return (null); },
            )
            : null}

          {!this.state.districtData.is_translator && !this.state.districtData.is_translator_link ? <li>Brak dostępności tłumacza języka migowego za pośrednictwem środków komunikacji elektronicznej.</li> : null}
        </ol>
        { this.state.districtData.has_mobile_app ?
          <div>
            <h3 id="a11y-aplikacje">
              <b>Aplikacje mobilne</b>
            </h3>
            <p>
              {(this.state.districtData.has_mobile_app && this.state.districtData.district === 'Urząd Miasta Gorzowa Wielkopolskiego') ? <span>Wersja Android: <a href={'https://play.google.com/store/apps/details?id=com.dm.giapgorzow'} id="a11y-url">https://play.google.com/store/apps/details?id=com.dm.giapgorzow</a></span> : null}
              {(this.state.districtData.has_mobile_app && this.state.districtData.district !== 'Urząd Miasta Gorzowa Wielkopolskiego') ? <span>Wersja iOS: <a href={'https://apps.apple.com/pl/app/euslugi-sip/id1484627587?l=pl'} id="a11y-url">https://apps.apple.com/pl/app/euslugi-sip/id1484627587?l=pl</a><br />Wersja Android: <a href={'https://play.google.com/store/apps/details?id=com.dm.giap'} id="a11y-url">https://play.google.com/store/apps/details?id=com.dm.giap</a></span> : null}.
            </p>
          </div>
        : null}
      </div>);
  }
}

export default DeklaracjaDostepnosci;



// WEBPACK FOOTER //
// src/components/DeklaracjaDostepnosci/DeklaracjaDostepnosci.js